import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_POLICIES_TRIPS_REQUEST,
    FETCH_POLICIES_TRIPS_SUCCESS,
    FETCH_POLICIES_TRIPS_FAILURE,
    FETCH_POLICIES_ACTIVITIES_REQUEST,
    FETCH_POLICIES_ACTIVITIES_SUCCESS,
    FETCH_POLICIES_ACTIVITIES_FAILURE,
} from '../actions/dataActions';
import {
    FETCH_POLICIES_REQUEST,
    FETCH_POLICIES_SUCCESS,
    FETCH_POLICIES_FAILURE,
    FETCH_ACTIVITY_POLICY_BY_ID_REQUEST,
    FETCH_ACTIVITY_POLICY_BY_ID_SUCCESS,
    FETCH_ACTIVITY_POLICY_BY_ID_FAILURE,
    CHANGE_ACTIVITY_POLICY_STATUS_REQUEST,
    CHANGE_ACTIVITY_POLICY_STATUS_SUCCESS,
    CHANGE_ACTIVITY_POLICY_STATUS_FAILURE,
    DELETE_ACTIVITY_POLICY_REQUEST,
    DELETE_ACTIVITY_POLICY_SUCCESS,
    DELETE_ACTIVITY_POLICY_FAILURE,
} from '../actions/policiesActions';
import {
    getPoliciesTrips,
    getPoliciesActivities,
    getActivityPolicyById,
    changeActivityPolicyStatus,
    deleteActivityPolicy,
    getPoliciesStartingToday,
} from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';

/**
 * Saga pour récupérer les polices d'activités (utilisée par AdminPolicies)
 */
function* fetchPoliciesSaga(action) {
    try {
        const params = action.payload || {};
        // Si use_today_endpoint est présent, utiliser l'endpoint getPoliciesStartingToday
        if (params.use_today_endpoint) {
            const filterDate = params.filter_date || null;
            const data = yield call(getPoliciesStartingToday, filterDate);
            yield put({ type: FETCH_POLICIES_SUCCESS, payload: data });
        } else {
            const data = yield call(getPoliciesActivities, params);
            yield put({ type: FETCH_POLICIES_SUCCESS, payload: data });
        }
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des polices');
        yield put({ type: FETCH_POLICIES_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour récupérer les polices de séjours (trips)
 */
function* fetchPoliciesTripsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getPoliciesTrips, params);
        yield put({ type: FETCH_POLICIES_TRIPS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des polices de séjours');
        yield put({ type: FETCH_POLICIES_TRIPS_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour récupérer les polices d'activités
 */
function* fetchPoliciesActivitiesSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getPoliciesActivities, params);
        yield put({ type: FETCH_POLICIES_ACTIVITIES_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des polices d\'activités');
        yield put({ type: FETCH_POLICIES_ACTIVITIES_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour récupérer une police d'activité par ID
 */
function* fetchActivityPolicyByIdSaga(action) {
    try {
        const policyId = action.payload;
        const data = yield call(getActivityPolicyById, policyId);
        yield put({ type: FETCH_ACTIVITY_POLICY_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement de la police d\'activité');
        yield put({ type: FETCH_ACTIVITY_POLICY_BY_ID_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour changer le statut d'une police d'activité
 */
function* changeActivityPolicyStatusSaga(action) {
    try {
        const { policyId, status } = action.payload;
        const data = yield call(changeActivityPolicyStatus, policyId, status);
        yield put({ type: CHANGE_ACTIVITY_POLICY_STATUS_SUCCESS, payload: { ...data, status } });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du changement de statut de la police');
        yield put({ type: CHANGE_ACTIVITY_POLICY_STATUS_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour supprimer une police d'activité
 */
function* deleteActivityPolicySaga(action) {
    try {
        const policyId = action.payload;
        yield call(deleteActivityPolicy, policyId);
        yield put({ type: DELETE_ACTIVITY_POLICY_SUCCESS, payload: policyId });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la suppression de la police');
        yield put({ type: DELETE_ACTIVITY_POLICY_FAILURE, payload: errorMessage });
    }
}

/**
 * Watcher pour les actions de polices
 */
export function* watchPoliciesRequests() {
    yield takeEvery(FETCH_POLICIES_REQUEST, fetchPoliciesSaga);
    yield takeEvery(FETCH_POLICIES_TRIPS_REQUEST, fetchPoliciesTripsSaga);
    yield takeEvery(FETCH_POLICIES_ACTIVITIES_REQUEST, fetchPoliciesActivitiesSaga);
    yield takeEvery(FETCH_ACTIVITY_POLICY_BY_ID_REQUEST, fetchActivityPolicyByIdSaga);
    yield takeEvery(CHANGE_ACTIVITY_POLICY_STATUS_REQUEST, changeActivityPolicyStatusSaga);
    yield takeEvery(DELETE_ACTIVITY_POLICY_REQUEST, deleteActivityPolicySaga);
}



